import React from 'react'
import { connect } from 'react-redux'
import { doGetDep, doSaveDep, doDelDep } from '../../reducers/actions'
import { hasChangedValues } from 'tyan/public/utility'
class DepDiv extends React.Component {
	state = {
		depID: this.props.depID,
		fatherID: this.props.fatherID,
		depth: this.props.depth,
	}
	componentDidMount = () => {
		const { onClose, dispatch, id, fatherID } = this.props
		dispatch(doGetDep({
			id,
			fatherID,
			onEnd: ({ errorMessage, initValues基本信息, fatherID, bDelete }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else if (initValues基本信息) {
					this.setState({ id, initValues基本信息, changedValues基本信息: {}, fatherID, bDelete })
				}
			}
		}))
	}

	handlerConfirm = () => {
		const { initValues基本信息, changedValues基本信息, id, fatherID, depth } = this.state
		const { onSave, onClose, dispatch } = this.props
		var newValues = changedValues基本信息
		if (id <= 0) {
			newValues = { '排序': initValues基本信息['排序'], ...changedValues基本信息 }
		}
		dispatch(doSaveDep({
			id,
			fatherID,
			depth,
			changedValues基本信息: newValues,
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('保存成功')
					onSave && onSave()
					onClose && onClose()
				}
			}
		}))
	}

	handlerDelete = () => {
		const { id } = this.state
		const { onSave, onClose, dispatch } = this.props

		Tyan.pubForm.showConfirm('确定要删除当前部门以及部门下所有人员？', () =>
			dispatch(doDelDep({
				id,
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						onSave && onSave()
						onClose && onClose()
					}
				}
			})))
	}


	handlerClose = () => {
		const { onClose } = this.props
		onClose && onClose()
	}

	fieldset基本信息 = () => {
		const { initValues基本信息, changedValues基本信息, depth } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		const name = depth == 2 ? '总部名称' : depth == 3 ? '公司名称' : depth == 4 ? '处级名称' : depth == 5 ? '部级名称' : '课级名称'
		return [
			{ _text: name, required: true, name: '部门名称', },
			{ _text: '部门编码', name: '部门编码', },
			{ _text: '账套ID', name: '账套ID', required: depth == 3, cdt: () => depth == 3 },
			{ _select: '负责人', name: '负责人', options: values.item负责人, required: true, },
			{ _date: '部门生效日期', required: true, },
			{ _select: '检测部门', name: '检测部门', options: ['是', '否'], cdt: () => depth == 5 || depth == 6 },
			{ _text: '备注', name: '备注', minWidth: '90%', maxRows: 3, cdt: () => depth == 5 || depth == 6 },
			{ _text: '公司全称（中文）', name: '公司全称', minWidth: '90%', cdt: () => depth == 3 },
			{ _text: '公司全称（英文）', name: '英文公司全称', minWidth: '90%', cdt: () => depth == 3 },
			{ _text: '公司地址（中文）', name: '公司地址', minWidth: '90%', cdt: () => depth == 3 },
			{ _text: '公司地址（英文）', name: '英文公司地址', minWidth: '90%', cdt: () => depth == 3 },
			{ _text: '电话', minWidth: '90%', cdt: () => depth == 3 },
			{ _text: '网址', minWidth: '90%', cdt: () => depth == 3 },
			{ _text: '外币发票编号前缀', minWidth: '90%', cdt: () => depth == 3 },
			{ _int: '排列次序', name: '排序', minWidth: '90%', textAlign: 'left' },
		]
	}

	canSave = () => {
		return hasChangedValues(this) && !Tyan.checkForm.checkLimited(this)
	}

	render() {
		const { showMessage: Message, showBody: Body, id } = this.props
		const { initValues基本信息, changedValues基本信息, bDelete } = this.state
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		const roles = Tyan.loginInfo.roles
		const canSave = this.canSave()
		return <Body data={this} maxWidth="600"
			controls={
				roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1 ?
					[
						{ _button: '关闭', icon: 'close', handler: this.handlerClose },
					] :
					[
						{ _button: '保存', icon: 'save', handler: this.handlerConfirm, disabled: !canSave },
						{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0 && bDelete, handler: this.handlerDelete },
						{ _button: '关闭', icon: 'close', handler: this.handlerClose },
					]}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1 },
				]}
		/>
	}
}

export default connect()(DepDiv)